<template>
	<TnButton
		comp-type="submit"
		v-bind="formElement"
		:dark="dark"
		:data-comp-lead="bedriftLead"
		:data-comp-cat="bedriftCategory"
		:disabled="submitting"
		:loading="submitting"
	></TnButton>
</template>

<script lang="ts" setup>
const props = defineProps({
	component: {
		type: Object,
		required: true,
	},
	dark: Boolean,
});

const formElement = useFormElement(props.component);

const bedriftLead = props.component.metadata && props.component.metadata.lead;
const bedriftCategory = props.component.metadata && props.component.metadata.category;

const submitting = computed(() => useFormStore().form.submitting || false);
</script>
